module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_BrightHoveAlbion.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_BrightHoveAlbion.png
// module id = 2181
// module chunks = 4